module.exports = __webpack_public_path__ + "img/user-group-empty.2e4e21e7.png";